export let ChatState;

(function (ChatState) {
  ChatState["RESUME"] = "resume";
  ChatState["INITIALISED"] = "init";
  ChatState["UNINITIALISED"] = "uninitialised";
  ChatState["PRE_CHAT"] = "preChat";
  ChatState["POST_CHAT"] = "postChat";
  ChatState["OFFLINE"] = "offline";
  ChatState["WAITING"] = "waiting";
  ChatState["CHATTING"] = "chatting";
  ChatState["ENDED"] = "ended";
  ChatState["INTERACTIVE"] = "interective";
  ChatState["NOT_FOUND"] = "Notfound";
})(ChatState || (ChatState = {}));

export let AgentsState;

(function (AgentsState) {
  AgentsState[AgentsState["ONLINE"] = 1] = "ONLINE";
  AgentsState[AgentsState["OFFLINE"] = 2] = "OFFLINE";
  AgentsState[AgentsState["BUSY"] = 4] = "BUSY";
})(AgentsState || (AgentsState = {}));

export let EngagementTypes;

(function (EngagementTypes) {
  EngagementTypes[EngagementTypes["PEELING_CORNER"] = 0] = "PEELING_CORNER";
  EngagementTypes[EngagementTypes["OVERLAY"] = 1] = "OVERLAY";
  EngagementTypes[EngagementTypes["TOASTER"] = 2] = "TOASTER";
  EngagementTypes[EngagementTypes["SLIDE_OUT"] = 3] = "SLIDE_OUT";
  EngagementTypes[EngagementTypes["EMBEDDED"] = 5] = "EMBEDDED";
  EngagementTypes[EngagementTypes["STICKY"] = 6] = "STICKY";
})(EngagementTypes || (EngagementTypes = {}));

export let ConversationState;

(function (ConversationState) {
  ConversationState["RESUME"] = "resume";
  ConversationState["INITIALISED"] = "initialised";
  ConversationState["UNINITIALISED"] = "uninitialised";
  ConversationState["WAITING"] = "waitning";
  ConversationState["CHATTING"] = "chatting";
  ConversationState["ENDED"] = "ended";
})(ConversationState || (ConversationState = {}));

export let State;

(function (State) {
  State["NOT_INITIALISED"] = "NOT_INITIALISED";
  State["INITIALISING"] = "INITIALISING";
  State["READY"] = "READY";
  State["FAILED"] = "FAILED";
  State["STARTED"] = "STARTED";
})(State || (State = {}));

export let WindowState;

(function (WindowState) {
  WindowState["OPEN"] = "OPEN";
  WindowState["CLOSED"] = "CLOSED";
  WindowState["MINIMISED"] = "MINIMISED";
  WindowState["UNKOWN"] = "UNKOWN";
})(WindowState || (WindowState = {}));

export let OfferState;

(function (OfferState) {
  OfferState["STARTED"] = "STARTED";
  OfferState["READY"] = "READY";
  OfferState["DISPLAYED"] = "DISPLAYED";
  OfferState["EXPIRED"] = "EXPIRED";
  OfferState["DECLINED"] = "DECLINED";
  OfferState["REMOVED"] = "REMOVED";
})(OfferState || (OfferState = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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